import { render, staticRenderFns } from "./SafeEmailUpdate.vue?vue&type=template&id=dcfab9d4&scoped=true&"
import script from "./SafeEmailUpdate.vue?vue&type=script&lang=js&"
export * from "./SafeEmailUpdate.vue?vue&type=script&lang=js&"
import style0 from "./SafeEmailUpdate.vue?vue&type=style&index=0&id=dcfab9d4&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "dcfab9d4",
  null
  
)

export default component.exports